export default ({...props}) => {
  return `
        height: 40vh;
        width: 100%;
    `
}
